import { PensionOption } from "../../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SourceType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { TransferType } from "../../../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { Instrument } from "../../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { PensionProtectionDetails } from "../../../../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { PensionTransfer } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/PensionTransfer";
import { ClientTradableInvestments } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { PensionBase } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { initAmount } from "../../../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionAction } from "../../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { BuyAction } from "../../../../Buy/Action/BuyAction";
import { PensionHelper } from "../../../Helpers/PensionHelper";
import { ChooseAssetsToSellAssets, ChooseAssetsToSwitchAssets } from "../Store/DrawdownCalculationStoreStatic";
import { MoneyOrPercentageType } from "../../../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";
import { processTypeEnum } from "../../../Resource/Contents";
import { GBPInvestmentCode, ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { ChooseAssetsToSellFor } from "../Resource/Contents";
import { InvestmentAllocation } from "../../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { Objects } from "../../../../../../../../react-core/Utils/Objects";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { getAssetsToSellTotalForIncome, getTotalIncome } from "../../IncomePaymentDetails/Helper/IncomePaymentHelper";
import { ChargesHelper } from "../../../Helpers/ChargesHelper";
import { ProductType } from "../../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { MoneyHelper } from "../../../../../../../Shared/Common/MoneyHelper";
import { CustomerPensionProtectionModel } from "../../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { Investment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { MoneyOrPercentage } from "../../../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { ProductDetailsStore } from "../../../../../../Stroes/Variable";
import { PensionPathwayInvestmentOption } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/PensionPathwayInvestmentOption";
import { SecurityType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { DrawdownCalculations } from "../../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownCalculations";
import { SwitchInstructionModel } from "../../../../../../../../Wrap/Models/Domains/Switch/SwitchInstructionModel";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";

export const isCappedOrFlexIOrUFPLS = (data: DrawdownModel): boolean => {
    return (
        [DrawdownType.Capped, DrawdownType.Flexible].includes(data?.DrawdownType) ||
        data?.PensionOption == PensionOption.UFPLS
    );
};

export const isRegualr = (data: DrawdownModel): boolean => {
    return data?.DrawdownType == DrawdownType.Regular;
};

export const calculateBeneiftsCharge = (data: DrawdownModel, v: number, type: string) => {
    const ratio = type == "income" ? 0.25 : 0.55;
    return parseInt(
        (ratio * v * 0.01 * (data?.LifetimeAllowance?.ChargeableCrystallisationPortion?.Amount || 0)).toString()
    );
};

export const calculateBeneiftsNet = (data: DrawdownModel, v: number, type: string) => {
    return (
        (data?.LifetimeAllowance?.ChargeableCrystallisationPortion?.Amount || 0) * v * 0.01 -
        calculateBeneiftsCharge(data, v, type)
    );
};

export const showBenefitTable = (data: DrawdownModel, lessThan75: boolean, hasEnhancedPensionProtection: boolean) => {
    if (!lessThan75) {
        return false;
    }
    if (hasEnhancedPensionProtection) {
        return false;
    }
    if (isCappedOrFlexIOrUFPLS(data)) {
        if (data?.LifetimeAllowance?.ChargeableCrystallisationPortion?.Amount > 0) {
            return true;
        }
        if (getCrystallisationAmount(data) > 0.9 * data?.LifetimeAllowance?.AvailablePersonalAllowance?.Amount) {
            return true;
        }
        return false;
    }
    if (isRegualr(data)) {
        return data?.LifetimeAllowance?.EstimatedTotalSlaUsedAfterAYear > 100;
    }
    return false;
};

export const showBenefitLastTwoColumn = (data: DrawdownModel) => {
    if (data?.DrawdownType == DrawdownType.Regular) {
        return false;
    }
    return data?.LifetimeAllowance?.ChargeableCrystallisationPortion?.Amount > 0;
};

export const hasEnhancedPensionProtection = (data: PensionBase): boolean => {
    return (
        data?.HasPensionProtection &&
        data?.PensionProtection?.PensionSchemeSpecificProtection?.PCLSEntitlement !== undefined
    );
};

export const calculateChooseAssetsToSellTotal = (data: DrawdownModel, type: ChooseAssetsToSellFor, drawdownIncomeAmendmentInstruction: DrawdownIncomeAmendmentInstruction = null, pensionBase?: any): number => {
    if (type === ChooseAssetsToSellFor.Income) {
        return getTotalIncome(data, drawdownIncomeAmendmentInstruction, pensionBase);
    } else if (data?.PensionOption === PensionOption.UFPLS) {
        return getAssetsToSellTotalForUFPLS(data);
    } else {
        return getAssetsToSellTotalForDrawdown(data);
    }
};

export const getInitialAdviserChargeForDrawdown = (data: DrawdownModel): number => {
    if (data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge?.SourceType == SourceType.ProductCash) {
        if (data.DrawdownAdviserCharge.DrawdownInitialAdviserCharge.Type == MoneyOrPercentageType.Money) {
            return data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge?.Money?.Amount || 0;
        } else {
            return MoneyHelper.roundNumberToDecimalPlaces(
                ((data?.CrystallisationDetails?.CrystallisationAmount.Amount || 0) *
                    (data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge?.Percentage || 0)) /
                100,
                2
            );
        }
    } else {
        return 0;
    }
};

export const needAssetsToSellForDrawdown = (data: DrawdownModel): boolean => {
    const crystallisationAmount = data?.CrystallisationDetails?.CrystallisationAmount?.Amount || 0;
    const availableCash = data?.CrystallisationDetails?.AvailableCash?.Amount || 0;
    const initialAdviserCharge = getInitialAdviserChargeForDrawdown(data);
    return crystallisationAmount + initialAdviserCharge - availableCash > 0;
};

export const getAssetsToSellTotalForDrawdown = (data: DrawdownModel): number => {
    let charges = 0;

    if (data?.DrawdownType !== DrawdownType.Regular && data?.DrawdownAdviserCharge?.DrawdownInitialAdviserCharge?.SourceType === SourceType.ProductCash) {
        const diac = data.DrawdownAdviserCharge.DrawdownInitialAdviserCharge;
        const crystallisationAmount = data?.CrystallisationDetails?.CrystallisationAmount?.Amount || 0;
        const diacAmount = diac?.Money?.Amount;

        if (diacAmount && diacAmount > 0) {
            charges = diacAmount;
        } else if (diac?.Percentage && diac.Percentage > 0 && crystallisationAmount > 0) {
            charges = (diac.Percentage / 100) * crystallisationAmount;
        }
    }

    return (
        charges +
        (data?.TaxFreeLumpSum?.Amount || 0) +
        (data?.ExcessBenefitsCalculations?.LumpSumTaxPayable?.Amount || 0) +
        (data?.ExcessBenefitsCalculations?.LumpSumTotalNetBenefits?.Amount || 0)
    );
};

export const getAssetsToSellTotalForUFPLS = (data: DrawdownModel): number => {
    return data?.CrystallisationDetails?.CrystallisationAmount?.Amount || 0;
}

export const calculateChooseAssetsToSwitchFromTotalForDrawdown = (data: DrawdownModel): number => {
    return (data?.CrystallisationDetails?.CrystallisationAmount?.Amount || 0) - getAssetsToSellTotalForDrawdown(data);
};

export const calculateChooseAssetsToSwtichFromTotalAssets = (data: DrawdownModel, totalAssetMarketValue: number): number => {
    const availableCash = data?.DrawdownCalculations?.AvailableCash?.Amount || 0;
    const atemptToSell = getAssetsToSellTotalForDrawdown(data);

    if (availableCash - atemptToSell >= 0) {
        //no need disinvest
        return totalAssetMarketValue;
    }
    else {
        //disinvest case
        return totalAssetMarketValue - atemptToSell;
    }
}

export const transformToAssetsTable = (investments: InvestmentAllocation[]): ChooseAssetsToSwitchAssets[] => {
    const _data: ChooseAssetsToSwitchAssets[] = [];

    investments.forEach((ele) => {
        _data.push({
            ProductId: ele.ProductId,
            Assets: ele.Name,
            ProductType: ele.Type,
            IsDeferred: false,
        });
    });

    return _data;
};

export const transformNewItem = (investments): ChooseAssetsToSwitchAssets[] => {
    return investments.map((ele) => {
        return {
            ProductId: ele.Instrument.ProductId,
            ProductCode: ele.Instrument.ProductCode,
            Assets: ele.Instrument.Name,
            ProductType: ele.Instrument.Type,
        };
    });
};

export const clearSwitchAllocationForDrawdown = (data: InvestmentAllocation[]): InvestmentAllocation[] => {
    const _data: any[] = data.concat();
    _data.forEach((v) => {
        v.Percentage = 0;
        v.Quantity = 0;
    });
    return _data;
};

export const showChooseAssetstoSell = (data: DrawdownModel, type: ChooseAssetsToSellFor, isWhatIf: boolean = false): boolean => {
    if (data?.PensionOption == PensionOption.UFPLS && !isWhatIf) {
        return false;
    }

    if (data?.DrawdownType == DrawdownType.Regular) {
        if (type && type == ChooseAssetsToSellFor.Income) {
            return false;
        } else {
            return true;
        }
    }

    if (type && type == ChooseAssetsToSellFor.Income) {
        return true;
    }

    const availableCash = data?.CrystallisationDetails?.AvailableCash?.Amount || 0;
    if ([DrawdownType.Capped, DrawdownType.Flexible].includes(data?.DrawdownType)) {
        return (getAssetsToSellTotalForDrawdown(data) - availableCash) > 0;
    }
    
    if (data?.PensionOption === PensionOption.UFPLS) {
        return (getAssetsToSellTotalForUFPLS(data) - availableCash) > 0;
    }
    return false;
};

export const showSwitchInvestments = (data: DrawdownModel, assets: ChooseAssetsToSwitchAssets[]): boolean => {
    if (data?.PensionOption != PensionOption.UFPLS && data?.DrawdownType == DrawdownType.Flexible) {
        if (data?.InvestmentPathwayAnswers?.InvestmentOption !== PensionPathwayInvestmentOption.CurrentInvestments
            && assets.some(asset => asset.ProductType != ProductType.OffPlatform)
        )
            return true;
        else
            return false;
    }
    return false;
};


export const hasProtectedRetireAgeOrSchemeTaxFreeCash = (pensionProtection: PensionProtectionDetails) => {
    return (
        pensionProtection?.PensionSchemeSpecificProtectionDetails?.ProtectedRetirementAge &&
        pensionProtection?.PensionSchemeSpecificProtectionDetails?.PclsEntitlement
    );
};

export const hasPrimaryProtection = (pensionProtection: CustomerPensionProtectionModel) => {
    return pensionProtection.Primary?.HasProtection;
};

export const getCrystallisationAmount = (data: DrawdownModel) => {
    if (isCappedOrFlexIOrUFPLS(data)) {
        return data?.CrystallisationDetails?.CrystallisationAmount?.Amount || 0;
    }
    if (isRegualr(data)) {
        return data?.RegularCrystallisationDetails?.Amount?.Amount || 0;
    }
    return 0;
};

export const totalCashValue = (data: PensionBase): number => {
    if (!data) {
        return 0;
    }

    return (
        PensionHelper.singlePaymentsTotal(data) +
        PensionHelper.getTransfersTotal(
            (data?.PensionTransfers || []).filter(
                (ele) =>
                    ele.TransferType == TransferType.Cash && ele.PensionSource == PensionArrangementType.Accumulation
            )
        )
    );
};

export const totalReRegValue = (data: PensionBase) => {
    let value = 0;
    const preRetireReregTransfer = (data?.PensionTransfers || []).filter(
        (ele) => ele.TransferType == TransferType.InSpecie && ele.PensionSource == PensionArrangementType.Accumulation
    );
    preRetireReregTransfer.forEach((regTransfer) => {
        value += regTransfer.ReRegisterValue.Amount ?? 0;
    });

    return value;
};

export const getAllPensionTransfersInvestments = (data: PensionBase): Investment[] => {
    const allPensionTransfersInvestments: Investment[] = [];
    for (const transfer of data?.PensionTransfers) {
        if (transfer.Instruments) {
            for (const instrument of transfer.Instruments) {
                if (instrument.Investment) {
                    allPensionTransfersInvestments.push(instrument.Investment);
                }
            }
        }
    }
    return allPensionTransfersInvestments;
};

export const calculateUnCrystallizationAmount = (data: PensionBase, process: ProcessType, isITFC: boolean): number => {
    if (
        process == ProcessType.Quote ||
        process == ProcessType.NB ||
        process == ProcessType.NBEC ||
        process == ProcessType.TopUpWithITFLS
    ) {
        return data?.DrawdownModel?.CrystallisationDetails?.UnCrystallisedValue?.Amount;
    }

    const preTotalCash = getPreTotalCash(data);
    const consolidateUncrystallisedValue = getConsolidateUncrystallisedValue(data, process);
    const initalAdviceCharge = getInitialAdviserCharge(data, preTotalCash);
    return consolidateUncrystallisedValue + preTotalCash - initalAdviceCharge;
};

const getConsolidateUncrystallisedValue = (data: PensionBase, process: ProcessType): number => {
    let consolidateUncrystallisedValue = 0;
    if (process == ProcessType.TopUpWithITFLS || process == ProcessType.TakePensionBenefits) {
        // if process is topup / TPB, uncrystallizationAmount need add all existed accumulation arrangements amount value
        // consolidate uncrystallised value
        consolidateUncrystallisedValue = data?.DrawdownModel?.CrystallisationDetails?.UnCrystallisedValue?.Amount || 0;
    }
    return consolidateUncrystallisedValue;
};

const getPreTotalCash = (data: PensionBase): number => {
    let preTotalCash = totalCashValue(data);
    preTotalCash += totalReRegValue(data);
    return preTotalCash;
};

const getProductCash = (): number => {
    const productCash = ProductDetailsStore.getSubAccount(SubAccountType.Npr);
    return productCash?.PortfolioCashDetail ? productCash.PortfolioCashDetail.reduce((total, ele) => total + (ele.AvailBalance || 0), 0) : 0;
}

const getInitialAdviserCharge = (data: PensionBase, preTotalCash: number): number => {
    const totalContribution = ChargesHelper.getTotalForIACEstimation(data, SubAccountType.Npr);
    const initalAdviceCharge =
        data?.InitialAdviserCharge?.SourceType == SourceType.WrapCash
            ? 0
            : data?.InitialAdviserCharge?.Type == MoneyOrPercentageType.Money
                ? (preTotalCash * (data?.InitialAdviserCharge?.Money?.Amount || 0)) / totalContribution
                : ((data?.InitialAdviserCharge?.Percentage || 0) * preTotalCash) / 100;
    return initalAdviceCharge;
};

export const calculateNetDrawdownValue = (data: DrawdownModel, pensionProtection: PensionProtectionDetails) => {
    const isPrimary = pensionProtection?.PensionPrimaryProtectionDetails;
    const amount =
        (data?.CrystallisationDetails?.CrystallisationAmount?.Amount || 0) -
        (isPrimary ? data?.TaxFreeLumpSum?.Amount || 0 : data?.CurrentPclsEntitlement?.Amount || 0) -
        (data?.ExcessBenefitsCalculations?.LumpSumTaxPayable?.Amount || 0) -
        (data?.ExcessBenefitsCalculations?.AdditionalIncomeTaxPayable?.Amount || 0) -
        (data?.ExcessBenefitsCalculations?.LumpSumTotalNetBenefits?.Amount || 0);
    return amount;
};

export const calculateAvailableCash = (data: PensionBase, process: ProcessType, isITFC: boolean): number => {
    if (
        process == ProcessType.Quote ||
        process == ProcessType.NB ||
        process == ProcessType.NBEC
    ) {
        return data?.DrawdownModel.CrystallisationDetails?.AvailableCash?.Amount;
    }

    const preTotalCash = getPreTotalCash(data);
    const uncrystallisedValue =
        calculateUnCrystallizationAmount(data, process, false) ??
        data?.DrawdownModel?.CrystallisationDetails?.UnCrystallisedValue?.Amount;
    const initialAdviserCharge = getInitialAdviserCharge(data, preTotalCash);
    const cashInvestment = (data?.PreRetirementInstrumentSelections?.Instruments || []).find(
        (ele) => ele?.Instrument?.Type == ProductType.Cash
    );

    const percentageForCash =
        (cashInvestment?.Single?.Percentage && cashInvestment.Single.Percentage !== 0)
            ? cashInvestment.Single.Percentage
            : (cashInvestment?.Transfer?.Percentage && cashInvestment.Transfer.Percentage !== 0)
                ? cashInvestment.Transfer.Percentage
                : 0;

    const productCash = process == ProcessType.TopUpWithITFLS ? getProductCash() : 0;

    const realTotalCash = (process == ProcessType.TopUpWithITFLS || isITFC)
        ? preTotalCash - initialAdviserCharge
        : (uncrystallisedValue ?? preTotalCash - initialAdviserCharge);

    return productCash + realTotalCash * percentageForCash * 0.01;
};

export const calculateAvailableToCrystallise = (data: PensionBase, process: ProcessType, isITFC: boolean): number => {

    if (process == ProcessType.TopUpWithITFLS || isITFC) {
        const preTotalCash = getPreTotalCash(data);
        const initalAdviceCharge = getInitialAdviserCharge(data, preTotalCash);

        return preTotalCash - initalAdviceCharge;
    }

    const availableToCrystallise = calculateUnCrystallizationAmount(data, process, false);
    return availableToCrystallise;
};

export const getChooseAssetsToSellTable = (
    data: PensionBase,
    filterPostRetirementAssets: boolean = false,
    existingAssets: ChooseAssetsToSellAssets[] = []
): ChooseAssetsToSellAssets[] => {
    const totalSingle: number = PensionHelper.singlePaymentsTotal(data);
    const totalClientRegular: number = PensionHelper.clientRegularPayment(data)?.Amount || 0;
    const totalThirdPartyRegular: number = PensionHelper.thirdPartyRegulaPayment(data)?.Amount || 0;
    const totalEmployerClientRegular: number = PensionHelper.employerRegularPayment(data)?.Amount || 0;
    const preTransfers: PensionTransfer[] = data.PensionTransfers
        ? data.PensionTransfers.filter(
            (ele) => ele.PensionSource == PensionArrangementType.Accumulation && ele.TransferType == TransferType.Cash
        )
        : [];
    const postTransfers: PensionTransfer[] = data.PensionTransfers
        ? data.PensionTransfers.filter(
            (ele) => ele.PensionSource == PensionArrangementType.Crystallised && ele.TransferType == TransferType.Cash
        )
        : [];
    const totalPre = preTransfers.reduce((total, ele) => {
        return total + initAmount(ele.CurrentValue);
    }, 0);
    const totalPost = postTransfers.reduce((total, ele) => {
        return total + initAmount(ele.CurrentValue);
    }, 0);
    const totalInstrument: ChooseAssetsToSellAssets[] = [];
    (data?.PreRetirementInstrumentSelections?.Instruments || []).forEach((element) => {
        if (!totalInstrument.find((item) => item.Id == element.Instrument.ProductId)) {
            const marketValue =
                (element.Single?.Percentage || 0) * 0.01 * totalSingle +
                (element.ClientRegular?.Percentage || 0) * 0.01 * totalClientRegular +
                (element.ThirdPartyRegular?.Percentage || 0) * 0.01 * totalThirdPartyRegular +
                (element.EmployerRegular?.Percentage || 0) * 0.01 * totalEmployerClientRegular +
                (element.Transfer?.Percentage || 0) * 0.01 * totalPre;
            totalInstrument.push({
                Assets: element.Instrument?.Name,
                MarketValue: { Amount: marketValue, Currency: CurrencyCode.GBP },
                Id: element.Instrument?.ProductId,
                ProductType: element?.Instrument?.Type,
                DisinvestAll: false,
                FactsheetUrl: element?.Instrument?.FinexDocumentUrl,
                IsDeferred: element?.Instrument?.IsDeferred,
            });
        }
    });
    (data?.PostRetirementInstrumentSelections?.Instruments || []).forEach((element) => {
        if (!totalInstrument.find((item) => item.Id == element.Instrument.ProductId)) {
            const marketValue =
                (element.Single?.Percentage || 0) * 0.01 * totalSingle +
                (element.ClientRegular?.Percentage || 0) * 0.01 * totalClientRegular +
                (element.ThirdPartyRegular?.Percentage || 0) * 0.01 * totalThirdPartyRegular +
                (element.EmployerRegular?.Percentage || 0) * 0.01 * totalEmployerClientRegular +
                (element.Transfer?.Percentage || 0) * 0.01 * totalPost;
            totalInstrument.push({
                Assets: element.Instrument?.Name,
                MarketValue: { Amount: marketValue, Currency: CurrencyCode.GBP },
                Id: element.Instrument?.ProductId,
                ProductType: element?.Instrument?.Type,
                DisinvestAll: false,
                FactsheetUrl: element?.Instrument?.FinexDocumentUrl,
                IsDeferred: element?.Instrument?.IsDeferred,
            });
        }
    });
    (data?.PensionTransfers || [])
        .filter(
            (ele) => ele.PensionSource != PensionArrangementType.Crystallised || filterPostRetirementAssets == false
        )
        .forEach((ele) => {
            (ele.Instruments || []).forEach((element) => {
                totalInstrument.push({
                    Assets: element.Investment?.DisplayName,
                    MarketValue: {
                        Amount: element?.Investment?.UnitPrice?.Amount * element.Units,
                        Currency: CurrencyCode.GBP,
                    },
                    Id: element.Investment?.ProductId,
                    ProductType: element?.Investment?.Type,
                    DisinvestAll: false,
                    FactsheetUrl: element.Investment?.FinexDocumentUrl,
                    IsDeferred: false,
                });
            });
        });

    existingAssets.forEach((ele) => {
        let instrument = totalInstrument.find((item) => item.Id == ele.Id);
        if (!instrument) {
            totalInstrument.push(ele);
        } else {
            instrument.MarketValue.Amount += ele.MarketValue.Amount;
        }
    });
    return totalInstrument;
};

export const getChooseAssetsToSwitchTable = (
    data: PensionBase,
    existingAssets: ChooseAssetsToSwitchAssets[] = []
): ChooseAssetsToSwitchAssets[] => {
    const totalSingle: number = PensionHelper.singlePaymentsTotal(data);
    const totalClientRegular: number = PensionHelper.clientRegularPayment(data)?.Amount || 0;
    const totalThirdPartyRegular: number = PensionHelper.thirdPartyRegulaPayment(data)?.Amount || 0;
    const totalEmployerClientRegular: number = PensionHelper.employerRegularPayment(data)?.Amount || 0;
    const preTransfers: PensionTransfer[] = data.PensionTransfers
        ? data.PensionTransfers.filter(
            (ele) => ele.PensionSource == PensionArrangementType.Accumulation && ele.TransferType == TransferType.Cash
        )
        : [];
    const postTransfers: PensionTransfer[] = data.PensionTransfers
        ? data.PensionTransfers.filter(
            (ele) => ele.PensionSource == PensionArrangementType.Crystallised && ele.TransferType == TransferType.Cash
        )
        : [];
    const totalPre = preTransfers.reduce((total, ele) => {
        return total + initAmount(ele.CurrentValue);
    }, 0);
    const totalPost = postTransfers.reduce((total, ele) => {
        return total + initAmount(ele.CurrentValue);
    }, 0);
    const totalInstrument: ChooseAssetsToSwitchAssets[] = [];
    (data?.PreRetirementInstrumentSelections?.Instruments || []).forEach((element) => {
        if (!totalInstrument.find((item) => item.ProductId == element.Instrument.ProductId)) {
            const marketValue =
                (element.Single?.Percentage || 0) * 0.01 * totalSingle +
                (element.ClientRegular?.Percentage || 0) * 0.01 * totalClientRegular +
                (element.ThirdPartyRegular?.Percentage || 0) * 0.01 * totalThirdPartyRegular +
                (element.EmployerRegular?.Percentage || 0) * 0.01 * totalEmployerClientRegular +
                (element.Transfer?.Percentage || 0) * 0.01 * totalPre;
            totalInstrument.push({
                Assets: element.Instrument?.Name,
                MarketValue: { Amount: marketValue, Currency: CurrencyCode.GBP },
                ProductId: element.Instrument?.ProductId,
                ProductType: element?.Instrument?.Type,
                SwitchAll: false,
                FactsheetUrl: element?.Instrument?.FinexDocumentUrl,
                IsDeferred: element?.Instrument?.IsDeferred,
            });
        }
    });
    (data?.PostRetirementInstrumentSelections?.Instruments || []).forEach((element) => {
        if (!totalInstrument.find((item) => item.ProductId == element.Instrument.ProductId)) {
            const marketValue =
                (element.Single?.Percentage || 0) * 0.01 * totalSingle +
                (element.ClientRegular?.Percentage || 0) * 0.01 * totalClientRegular +
                (element.ThirdPartyRegular?.Percentage || 0) * 0.01 * totalThirdPartyRegular +
                (element.EmployerRegular?.Percentage || 0) * 0.01 * totalEmployerClientRegular +
                (element.Transfer?.Percentage || 0) * 0.01 * totalPost;
            totalInstrument.push({
                Assets: element.Instrument?.Name,
                MarketValue: { Amount: marketValue, Currency: CurrencyCode.GBP },
                ProductId: element.Instrument?.ProductId,
                ProductType: element?.Instrument?.Type,
                SwitchAll: false,
                FactsheetUrl: element?.Instrument?.FinexDocumentUrl,
                IsDeferred: element?.Instrument?.IsDeferred,
            });
        }
    });
    (data?.PensionTransfers || []).forEach((ele) => {
        (ele.Instruments || []).forEach((element) => {
            totalInstrument.push({
                Assets: element.Investment?.DisplayName,
                MarketValue: {
                    Amount: element?.Investment?.UnitPrice?.Amount * element.Units,
                    Currency: CurrencyCode.GBP,
                },
                ProductId: element.Investment?.ProductId,
                ProductType: element?.Investment?.Type,
                SwitchAll: false,
                FactsheetUrl: "",
                IsDeferred: false,
            });
        });
    });

    existingAssets.forEach((ele) => {
        let instrument = totalInstrument.find((item) => item.ProductId == ele.ProductId);
        if (!instrument) {
            totalInstrument.push(ele);
        } else {
            instrument.MarketValue.Amount += ele.MarketValue.Amount;
        }
    });
    return totalInstrument;
};

export const getSellableAssets = (type: SubAccountType, hierarchyid, subAccountHierarchyId, callback?) => {
    BuyAction.getReuseHoldings(hierarchyid, subAccountHierarchyId, 0, (data: ClientTradableInvestments) => {
        const inidividual = data.CurrentIndividualHoldings.filter(
            (ele) => (ele.CurrQuantity > 0 && ele.MarketValue?.Amount > 0) || ele.DisplayName == "GBP Cash"
        );
        const model = data.CurrentModelHoldings.filter((ele) => ele.CurrQuantity > 0 && ele.MarketValue?.Amount > 0);
        let ids = inidividual.map((ele) => ele.ProductId);
        ids = ids.concat(model.map((ele) => ele.ProductId));
        const query: InstrumentSearchQuery = {
            ProductWrapperTypes: [type],
            ProductIds: ids,
            CanBeSold: true,
            ResultsPerPage: ids.length,
            ServiceProposition: data.AccountServiceProposition,
        };

        const currentAssets: ChooseAssetsToSellAssets[] = [];
        const currentAssetsToSwitch: ChooseAssetsToSwitchAssets[] = [];
        InvestmentSelectionAction.searchInstruments(query, subAccountHierarchyId, (result: Instrument[]) => {
            result.forEach((ele) => {
                const obj = data.CurrentIndividualHoldings.find((item) => item.ProductId == ele.ProductId);
                const model = data.CurrentModelHoldings.find((item) => item.ProductId == ele.ProductId);
                if (obj && obj.SecurityType !== SecurityType.OffPlatform) {
                    currentAssets.push({
                        Assets: obj.DisplayName,
                        MarketValue: obj.MarketValue,
                        ProductType: ele.Type,
                        Id: obj.ProductId,
                        DisinvestAll: false,
                        FactsheetUrl: obj.FinexFactSheetUrl,
                        IsDeferred: ele?.IsDeferred,
                        HasOpenValueSellOrder: obj.HasOpenValueSellOrder,
                    });
                    if (ele.Type != ProductType.Cash) {
                        currentAssetsToSwitch.push({
                            Assets: obj.DisplayName,
                            MarketValue: obj.MarketValue,
                            ProductType: ele.Type,
                            ProductId: obj.ProductId,
                            SwitchAll: false,
                            FactsheetUrl: obj.FinexFactSheetUrl,
                            IsDeferred: ele?.IsDeferred,
                            HasOpenValueSellOrder: obj.HasOpenValueSellOrder,
                        });
                    }
                } else if (model && model.SecurityType !== SecurityType.OffPlatform) {
                    currentAssets.push({
                        Assets: model.DisplayName,
                        MarketValue: model.MarketValue,
                        ProductType: model.Type,
                        Id: model.ProductId,
                        DisinvestAll: false,
                        FactsheetUrl: model.FinexFactSheetUrl,
                        IsDeferred: ele?.IsDeferred,
                        HasOpenValueSellOrder: model.HasOpenValueSellOrder,
                    });
                    currentAssetsToSwitch.push({
                        Assets: model.DisplayName,
                        MarketValue: model.MarketValue,
                        ProductType: model.Type,
                        ProductId: model.ProductId,
                        SwitchAll: false,
                        FactsheetUrl: model.FinexFactSheetUrl,
                        IsDeferred: ele?.IsDeferred,
                        HasOpenValueSellOrder: model.HasOpenValueSellOrder,
                    });
                }
            });
            if (callback) {
                callback({
                    assetsToSell: currentAssets,
                    assetsToSwitch: currentAssetsToSwitch,
                });
            }
        });
    });
};

export const getSellableAssetsAfterSwitch = (type: SubAccountType, hierarchyid, subAccountHierarchyId, switchInstruction: SwitchInstructionModel, callback?) => {
    const buyAllocations = switchInstruction?.BuyAllocations ?? [];
    const sellAllocations = switchInstruction?.SellAllocations ?? [];
    BuyAction.getReuseHoldings(hierarchyid, subAccountHierarchyId, 0, (data: ClientTradableInvestments) => {
        let inidividual = data.CurrentIndividualHoldings.filter(
            (ele) => (ele.CurrQuantity > 0 && ele.MarketValue?.Amount > 0) || ele.DisplayName == "GBP Cash"
        );
        let model = data.CurrentModelHoldings.filter((ele) => ele.CurrQuantity > 0 && ele.MarketValue?.Amount > 0);
        let ids = inidividual.map((ele) => ele.ProductId);
        ids = ids.concat(model.map((ele) => ele.ProductId));
        ids = ids.concat(buyAllocations?.map((ele) => ele.ProductId));

        const query: InstrumentSearchQuery = {
            ProductWrapperTypes: [type],
            ProductIds: ids,
            CanBeSold: true,
            ResultsPerPage: ids.length,
            ServiceProposition: data.AccountServiceProposition,
        };

        const currentAssets: ChooseAssetsToSellAssets[] = [];
        InvestmentSelectionAction.searchInstruments(query, subAccountHierarchyId, (result: Instrument[]) => {
            result.forEach((ele) => {
                const obj = data.CurrentIndividualHoldings.find((item) => item.ProductId == ele.ProductId);
                const model = data.CurrentModelHoldings.find((item) => item.ProductId == ele.ProductId);
                if (obj && obj.SecurityType !== SecurityType.OffPlatform) {
                    currentAssets.push({
                        Assets: obj.DisplayName,
                        MarketValue: { Amount: obj.MarketValue.Amount - (sellAllocations?.find((ele) => ele.ProductId == obj.ProductId)?.Value?.Amount ?? 0), Currency: obj.MarketValue.Currency },
                        ProductType: ele.Type,
                        Id: obj.ProductId,
                        DisinvestAll: false,
                        FactsheetUrl: obj.FinexFactSheetUrl,
                        IsDeferred: ele?.IsDeferred,
                        HasOpenValueSellOrder: obj.HasOpenValueSellOrder,
                    });
                } else if (model && model.SecurityType !== SecurityType.OffPlatform) {
                    currentAssets.push({
                        Assets: model.DisplayName,
                        MarketValue: { Amount: model.MarketValue.Amount - (sellAllocations?.find((ele) => ele.ProductId == model.ProductId)?.Value?.Amount ?? 0), Currency: model.MarketValue.Currency },
                        ProductType: model.Type,
                        Id: model.ProductId,
                        DisinvestAll: false,
                        FactsheetUrl: model.FinexFactSheetUrl,
                        IsDeferred: ele?.IsDeferred,
                        HasOpenValueSellOrder: model.HasOpenValueSellOrder,
                    });
                } else if (buyAllocations?.some((x) => ele.ProductId === x.ProductId)) {
                    currentAssets.push({
                        Assets: ele.Name,
                        MarketValue: buyAllocations.find((x) => x.ProductId === ele.ProductId).Value,
                        ProductType: ele.Type,
                        Id: ele.ProductId,
                        DisinvestAll: false,
                        FactsheetUrl: "",
                        IsDeferred: ele?.IsDeferred,
                        HasOpenValueSellOrder: false,
                    });
                }
            });
            if (callback) {
                callback({
                    assetsToSell: currentAssets,
                });
            }
        });
    });
};

export const getUpdatedAssetsToSell = (
    usedAllocations: InvestmentAllocation[],
    usedForTotal: number,
    assets: ChooseAssetsToSellAssets[]
) => {
    if (isNullOrEmpty(usedAllocations) || usedForTotal == 0) {
        return assets;
    }
    const updatedAssets = Objects.cloneObject(assets);
    usedAllocations.map((ele, index) => {
        if (ele.Percentage > 0) {
            const assetIndex = updatedAssets.findIndex((x) => x.Id == ele.ProductId);
            if (assetIndex > -1) {
                updatedAssets[assetIndex].MarketValue = {
                    Amount: updatedAssets[assetIndex].MarketValue.Amount - usedForTotal * ele.Percentage * 0.01,
                    Currency: updatedAssets[assetIndex].MarketValue.Currency,
                };
            }
        }
    });
    return updatedAssets;
};

export const ShouldDisplayItfcChargesMessage = (
    processType: processTypeEnum,
    reason?: ChooseAssetsToSellFor
): boolean => {
    if (reason === ChooseAssetsToSellFor.Income) {
        return false;
    }
    const nonEligibleProcessTypes = [processTypeEnum.GadReview];
    return !nonEligibleProcessTypes.some((type) => type === processType);
};

export const hasPensionSchemeSpecificProtectionWithSchemeSpecificTaxFreeCash = (pensionProtection: CustomerPensionProtectionModel) => {
    return pensionProtection?.PensionSchemeSpecificProtection?.HasProtection
        && pensionProtection?.PensionSchemeSpecificProtection?.PCLSEntitlement > 0;
};

export const hasPrimaryProtectionWithPclsProtection = (pensionProtection: CustomerPensionProtectionModel) => {
    return (pensionProtection.Primary?.HasProtection ?? false) && pensionProtection.Primary?.ProtectionAmount != null;
};

export const hasPrimaryProtectionWithoutPclsProtection = (pensionProtection: CustomerPensionProtectionModel) => {
    return (pensionProtection.Primary?.HasProtection ?? false) && pensionProtection.Primary?.ProtectionAmount == null;
};

export const UfplsNotEnoughToSupportPcls = (drawdownCalculations: DrawdownCalculations) => {
    return (drawdownCalculations?.MaximumUfplsAvailable?.Amount ?? 0) * 0.25 < (drawdownCalculations?.PensionCommencementLumpSum?.CurrentPclsEntitlement?.Amount ?? 0);
}

export const hasEnhancedProtectionWithPclsProtection = (pensionProtection: CustomerPensionProtectionModel) => {
    return (pensionProtection.Enhanced?.HasProtection ?? false) && pensionProtection.Enhanced?.EntitlementPercentage > 0
};

export const hasOtherEnhancementFactors = (pensionProtection: CustomerPensionProtectionModel) => {
    return pensionProtection?.LifetimeAllowanceEnhancements?.length > 0;
}

export const shouldRestictUfpls = (pensionProtection: CustomerPensionProtectionModel, data: DrawdownModel) => {
    return hasPrimaryProtectionWithPclsProtection(pensionProtection)
        || hasPensionSchemeSpecificProtectionWithSchemeSpecificTaxFreeCash(pensionProtection)
        || (hasPrimaryProtectionWithoutPclsProtection(pensionProtection) && UfplsNotEnoughToSupportPcls(data?.DrawdownCalculations))
        || hasEnhancedProtectionWithPclsProtection(pensionProtection);
}

export const shouldShowUfplsErrorMessage = (pensionProtection: CustomerPensionProtectionModel, data: DrawdownModel) => {
    return (hasPrimaryProtectionWithPclsProtection(pensionProtection) ||
        hasOtherEnhancementFactors(pensionProtection)) &&
        data.PensionOption == PensionOption.UFPLS &&
        data.CrystallisationDetails?.CrystallisationAmount?.Amount > data.DrawdownCalculations?.MaximumUfplsAvailable?.Amount;
}

export const getAvailableCashAfterDeduction = (data: DrawdownModel): number => {
    const availableCash = data?.DrawdownCalculations?.AvailableCash?.Amount || 0;
    const disinvetmentAmount = getAssetsToSellTotalForDrawdown(data) - availableCash;
    if (disinvetmentAmount > 0) {
        return availableCash;
    }
    return Math.abs(disinvetmentAmount);
}
